<template >
  <div class="container__suscriptorSearch">
    <div class="container__suscriptorSearch--title">
      <span
        class="title__interesados--container"
      >
        &#128578;
      </span>
      <h1 class="icon__interesados--container title__interesados--container">Ayúdanos a mejorar</h1>
    </div>

    <p class="m-0">
      <span>
        ¿Cómo ha sido tu experiencia al completar este formulario?
      </span>
      <v-tooltip
        transition="fade-transition"
        bottom
      >
        <template v-slot:activator="{  on }">
            <span
              v-on="on"
              class="emojic emojic4"
              @click="disableStarts ? selectEmojic(4) : null"
            >
              &#128512;
            </span>
        </template>
        <span >Muy fácil</span>
      </v-tooltip>

      <v-tooltip
        transition="fade-transition"
        bottom
      >
        <template v-slot:activator="{  on }">
            <span
              v-on="on"
              class="emojic emojic3"
              @click="disableStarts ? selectEmojic(3) : null"
            >
              &#128578;
            </span>
        </template>
        <span >Fácil</span>
      </v-tooltip>

      <v-tooltip
        transition="fade-transition"
        bottom
      >
        <template v-slot:activator="{  on }">
            <span
              v-on="on"
              class="emojic emojic2"
              @click="disableStarts ? selectEmojic(2) : null"
            >
              &#128577;
            </span>
        </template>
        <span >Difícil</span>
      </v-tooltip>

      <v-tooltip
        transition="fade-transition"
        bottom
      >
        <template v-slot:activator="{  on }">
            <span
              v-on="on"
              class="emojic emojic1"
              @click="disableStarts ? selectEmojic(1) : null"
            >
              &#128545;
            </span>
        </template>
        <span >Muy difícil</span>
      </v-tooltip>
    </p>
    <v-scroll-y-reverse-transition>
      <v-textarea
        v-if="starsScore === 1 || starsScore === 2"
        class="mt-4"
        outlined
        hide-details="auto"
        v-model="comment"
        :auto-grow="true"
        no-resize
        rows="3"
        :autofocus="true"
        :placeholder="'*'+$t('views.form.feedbackPlaceholder')"
        :error="starsScore <= 2 && !comment"
        :error-messages="starsScore <= 2 && !comment ? 'Por favor, introduce un valor' : null"
        />
      </v-scroll-y-reverse-transition>
    </div>
  </template>

<script>
// :placeholder="$t('ticketActions.acceptClosing.valorationPlaceholder')"
export default {
  props: {
    label: String,
    params: { type: Object, default: () => ({}) },
    inputData: Object,
  },
  data() {
    return {
      comment: null,
      disableStarts: true,
      starsScore: 0,
      showComment: false,
    };
  },
  watch: {
    starsScore() { this.emitData(); },
    comment() { this.emitData(); },
  },
  methods: {
    selectEmojic(index) {
      this.starsScore = index;
      for (let i = 1; i <= 4; i += 1) {
        const element = document.querySelector(`.emojic${i}`);
        if (element && i !== index) {
          element.classList.add('grayscale');
        } else if (element) {
          element.classList.remove('grayscale');
        }
      }
      if (index > 2) {
        this.comment = null;
      }
    },
    emitData() {
      this.$emit('update:inputData', {
        value: {
          starsScore: this.starsScore,
          comment: this.comment,
        },
        item: null,
      });
    },
  },
};
</script>

<style>
  .grayscale {
    filter: grayscale(1);
  }
  .container__emojic {
    display: flex;
    margin-top: 1rem;
  }
  .emojic {
    cursor: pointer;
    font-size: 1.5rem;
    margin: 0 0.7rem;
  }

  .card__container {
    padding: 0.5rem 1rem;
  }
  .card__item {
    margin: 0.5rem 0;
  }
  .card__info {
    display: flex;
    justify-content: space-between;
  }
  .container__btnExpand {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    width: 100%;
  }

  .icon-background {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 13.5px;
  }

  .adjuntChip {
    border: 2px solid #f1f1f1 !important;
  }

  .container__userCustomer {
    margin-top: 1rem;
  }

  .card__element_suscriptores div {
    padding: 0;
  }

  .btn__delete__interesado {
    cursor: pointer;
  }

  .container__suscriptorSearch {
    border: 1px solid #afadad;
    position: relative;
    padding: 1.5rem;
    margin-top: 1rem;
  }
  .container__suscriptorSearch--title {
    position: absolute;
    top: -31px;
    left: 17px;
    background-color: #ffffff;
    padding-right: 1rem;
    display: flex;
    align-items: center;
  }
  .icon__interesados--container {
    font-size: 4rem;
  }
  .title__interesados--container {
    font-size: 1.2rem;
    margin-top: 1.2rem;
  }
  .m-1 {
    margin: 1rem 0;
  }
  .text__subtitle {
    font-size: .9rem;
    margin-bottom: 1rem;
  }
  .text__interesado__help {
    font-size: 10.4px !important;
    margin-top: 0.3rem;
    margin-bottom: 0 !important;
  }
  .text__interesado__error {
    color: #b64351 !important;
    margin-top: 0.5rem;
  }
  .input__search--interesado {
    margin-top: 1rem !important;
  }
  .m-0 {
    margin: 0!important;
  }
</style>
